import './App.css';
import React from 'react';

const Setting = () => {
  return (
    <div className="coming-soon">
      <h1>Coming Soon</h1>
    </div>
  );
};

export default Setting;
